exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CodeMirror-scroll{\r\n    width:100%;\r\n    border: 1px solid #dfdfdf;\r\n}", ""]);

// exports
